import React, { useState } from 'react';
import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ModalPopup from '../ModalPopup';
import './contactBanner.css';
import Button from '../Shared/Button';

const ContactBanner = () => {
  const [showModal, setShowModal] = useState(false);

  const handleButtonClick = () => {
    setShowModal(true);
  };

  const handleClose = () => setShowModal(false);

  return (
    <>
      <Container fluid className="parabola up"></Container>
      <Container fluid className="contrastBox">
        <div className="bannerContent">
          <Container fluid>
            <Row>
              <Col className='leftCol' xs={12} md={4}>
                <p>
                  Interested in what we are doing and<br />
                  would like to hear more about it?
                </p>
                <Row>
                  <Col>
                    <Button text='Contact us now' buttonStyle='blue' onClick={handleButtonClick} />
                  </Col>
                </Row>
              </Col>
              <Col xs={12} md={4}>
              </Col>
              <Col className='rightCol' xs={12} md={4}>
                <p>
                  Are you a Capgemini employee and<br />
                  want to get involved with the team?
                </p>
                <Row>
                  <Col>
                    <Button text='Log in and join' buttonStyle='blue-transparent' navigateTo='/login' />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
      <ModalPopup
        show={showModal}
        handleClose={handleClose}
        description="We'd love to hear from you!"
        title={"Contact us"}
        image="https://firebasestorage.googleapis.com/v0/b/riotlabs-web.appspot.com/o/images%2Frobot-thanks.png?alt=media&token=6120450a-5c26-4c4b-b4fe-4919cfb7240c"
        buttonText="Ok"
        type={"form"}
      />
      <Container fluid className="parabola down"></Container>
    </>
  );
};

export default ContactBanner;
